<template>
  <div>
    <p v-if="selected" class="selected">{{ selected.name }}</p>
    <el-button type="primary" @click="dialogVisible = true">
      Выбрать
    </el-button>
    <el-button @click="selected = null"> Очистить </el-button>
    <el-dialog title="Cекции" :visible.sync="dialogVisible">
      <div class="grid">
        <div
          v-for="(item, i) of data"
          :key="i"
          class="item"
          @click="(selected = item), (dialogVisible = false)"
        >
          <div class="item-img">
            <img :src="mediaUrl + '/' + item.image" />
          </div>
          <div class="item-title">
            {{ item.name }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    value: {
      type: [Array, String, Number],
      required: false,
      default() {
        const { multiple } = this.params;
        if (multiple) {
          return [];
        }
        return null;
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["mediaUrl"]),
    /**
     * Внутри компонента используем объект с названием и id
     * наружу отдаем массив с id
     */
    selected: {
      get() {
        if (Array.isArray(this.value) && Number(this.value[0])) {
          return this.value.map((e) =>
            this.data.find((item) => item[this.params.key] === e)
          );
        }
        if (typeof this.value !== "object") {
          return this.data.find((item) => item[this.params.key] === this.value);
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val ? val[this.params.key] : null);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(3, 261px);
  grid-gap: 10px;
  justify-content: center;
}
.item {
  cursor: pointer;
  background: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  width: 261px;
  height: 182px;
  box-shadow: 0px 12px 20px -4px rgba(0, 0, 0, 0.18);
  &-img {
    width: 261px;
    height: 124px;
    background: #8f9399;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  &-title {
    height: 58px;
    width: calc(100% - 20px);
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 16px;
    line-height: 120%;
  }
}
.el-dialog {
  width: 100%;
}
.selected {
  margin: 0 0 20px 0;
}
</style>
